var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.section.description)?_c('div',{staticClass:"label-text",staticStyle:{"margin-left":"26px"}},[_c('WithRequired',{attrs:{"required":false,"text":_vm.section.description,"cut_text":true}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }